module.exports = __webpack_public_path__ + "static/media/noun-done-1195562-142350.9908e797.svg";